import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import { paramsFilter } from "@/services/OrderBankDarah";
import { OrderBankDarahFilter, RekapOrderResponse } from "@/types/order_bank_darah";

async function list(f: OrderBankDarahFilter): Promise<RekapOrderResponse> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-order", { params: paramsFilter(f) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function downloadExcel(f: OrderBankDarahFilter): Promise<void> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-order/excel", {
      params: paramsFilter(f),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `rekap-order-bank-darah_${f.tgl_start}_${f.tgl_end}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { list, downloadExcel };
